import { Fragment, useCallback, useEffect, useState } from "react"
import { Modal } from "common/Modal"
import { Table } from "common/Table/Table"
import { useDebounce } from "hooks/useDebounce"
import { useNotifications } from "hooks/useNotification"
import {
  convertTo12HourFormat,
  exportToCSV,
  formatDate,
  hasTimeSlotConflict,
  validateTimeGap,
} from "utils/funcs"
import classNames from "classnames"
import CopyText from "common/CopyText"
import UserService from "services/user.service"
import swal from "sweetalert"
import { ALPHABETS, NEW_TIMEZONE } from "utils/constants"
import { useRouter } from "hooks/useRouter"

const service = new UserService()

export const DealerMediaAds = () => {
  const { push } = useRouter()
  const columns = [
    {
      key: "badge_id",
      dbColName: "_id",
      title: "Ad id",
      render: (id) => (
        <CopyText copyText={id} text={`${id.toString().slice(0, 8)}...`} />
      ),
    },
    {
      key: "office_id",
      dbColName: "officeId",
      title: "office id",
      render: (id) => (
        <CopyText copyText={id} text={`${id?.toString().slice(0, 8)}...`} />
      ),
    },
    {
      key: "isApprovedByOwner",
      dbColName: "isApprovedByOwner",
      title: "is Approved By Owner",
      // render: (id) => (
      //   <CopyText copyText={id} text={`${id?.toString().slice(0, 8)}...`} />
      // ),
    },
    {
      key: "companyTitle",
      dbColName: "companyInfo",
      title: "Company Name",
      render: (company) => company?.title,
    },
      {
      key: "companyType",
      dbColName: "companyInfo",
      title: "Company type",
      render: (company) => company?.companyType,
    },
    {
      key: "campaignName",
      dbColName: "campaignName",
      title: "campaign Name",
    },

    {
      key: "campaignType",
      dbColName: "campaignType",
      title: "campaign Type",
    },
    { key: "adAmount", dbColName: "adAmount", title: "ad Amount" },
    { key: "payment", dbColName: "payment", title: "payment status" },
    { key: "dayCount", dbColName: "dayCount", title: "Day count" },
    // { key: "adType", dbColName: "adType", title: "ad Type" },
    { key: "screeningLevel", dbColName: "screeningLevel", title: "screening Level" },
        {
      key: "epPositionTitle",
      dbColName: "epPositionTitle",
      title: "Position Title",
    },
    {
      key: "epJobDescription",
      dbColName: "epJobDescription",
      title: "Job Description",
    },
    {
      key: "epBenefitsOffered",
      dbColName: "epBenefitsOffered",
      title: "Benefits Offered",
    },
    { key: "badgeId", dbColName: "badgeId", title: "badgeId" },
    { key: "userEmail", dbColName: "userEmail", title: "user Email" },
    { key: "gmailEmail", dbColName: "gmailEmail", title: "gmail Email" },
    { key: "fullName", dbColName: "fullName", title: "full Name" },
    { key: "companyId", dbColName: "companyId", title: "company Id" },
    { key: "phone", dbColName: "phone", title: "phone" },
    { key: "adSpent", dbColName: "adSpent", title: "ad Spent" },
    { key: "payment", dbColName: "payment", title: "payment status" },

    { key: "notes", dbColName: "notes", title: "notes" },
    { key: "calendarId", dbColName: "calendarId", title: "calendar Id" },
    { key: "meetLink", dbColName: "meetLink", title: "meet Link" },
    { key: "address", dbColName: "address", title: "address" },
    { key: "city", dbColName: "city", title: "city" },
    { key: "state", dbColName: "state", title: "state" },
    { key: "zipCode", dbColName: "zipCode", title: "zip Code" },
    {
      key: "adApprovalStatus",
      dbColName: "adApprovalStatus",
      title: "ad Approval Status",
    },
    {
      key: "adProcessingStatus",
      dbColName: "adProcessingStatus",
      title: "ad ProcessingStatus",
    },
    {
      key: "createdAt",
      dbColName: "createdAt",
      title: "createdAt",
      render: (date) => formatDate(date),
    },
    {
      key: "action",
      freeze: true,
      freezeIndex: "right-0",
      title: "action",
      render: (row) => {
        return (
          <div className="flex items-center justify-center gap-4">
            <button
              type="button"
              className="text-blue-500"
              onClick={() => push(`/dealer-ad/${row._id}`)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                />
              </svg>
            </button>
            <button
              type="button"
              className="text-blue-500"
              onClick={() => {
                setShowModal(true)
                setState({
                  id: row._id,
                  adApprovalStatus: row.adApprovalStatus,
                  adProcessingStatus: row.adProcessingStatus,
                  adSpent: row.adSpend,
                  campaignName: row.campaignName,
                  adAmount: row.adAmount,
                  notes: row.notes,
                })
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"
                />
              </svg>
            </button>
            <button
              type="button"
              className="text-red-500"
              onClick={() => handleDelete(row._id)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
                />
              </svg>
            </button>
          </div>
        )
      },
    },
  ]

  const [data, setData] = useState([])
  const [totalItems, setTotalItems] = useState(0)
  const [loading, setLoading] = useState(false)
  const [exporting, setExporting] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [companies, setCompanies] = useState([])
  const [companyUsers, setCompanyUsers] = useState([])
  const [addModal, setAddModal] = useState(false)
  const [formData, setFormData] = useState({
    badgeId: "",
    gmailEmail: "",
    officeId: "",
    officeName: "",
    campaignName: "",
    isAiEnable: false,
    recruiting_interview: [
      {
        block_name: "A",
        date: "",
        start_time: "",
        end_time: "",
        interview_type: "Virtual Meeting",
        time_zone: "",
        custom_location: false,
        office_name: "",
        address: "",
        city: "",
        state: "",
        zip_code: "",
      },
    ],
  })
  const [submitting, setSubmitting] = useState(false)
  const [offices, setOffices] = useState([])
  const [state, setState] = useState({
    id: "",
    adApprovalStatus: "",
    adAmount: "",
    adProcessingStatus: "",
    campaignName: "",
    adSpent: "",
    notes: "",
  })
  const [showRecruiting, setShowRecruiting] = useState(false)
  const [pagination, setPagination] = useState({
    pageNumber: 1,
    pageSize: 100,
    adProcessingStatus: "",
    adApprovalStatus: "",
    fullName: "",
  })

  const debounced = useDebounce(pagination, 500)
  const { errorMessage, successMessage } = useNotifications()

  const fetchData = useCallback(() => {
    setLoading(true)
    service
      .dealersMediaAds(debounced)
      .then((resp) => {
        setData(resp.data.data)
        setTotalItems(+resp.data.totalDocument)
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [debounced])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  useEffect(() => {
    service
      .getCompanies()
      .then((resp) => {
        setCompanies(resp.data.data)
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [])

  const handleExport = () => {
    setExporting(true)
    service
      .dealersMediaAds({
        ...pagination,
        pageNumber: "",
        pageSize: "",
        isDownload: "true",
      })
      .then((resp) => {
        exportToCSV(resp.data.data, "reps")
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        setExporting(false)
      })
  }

  const handleChangeCompany = (event) => {
    const id = event.target.value
    const findCompany: any = companies.find(
      (company: { companyId: string }) => company.companyId === id
    )
    const badgeid = findCompany?.owner?.badgeId || ""

    setFormData({
      ...formData,
      badgeId: badgeid,
    })
    service
      .companyUsers(id, badgeid || "")
      .then((resp) => {
        setCompanyUsers(resp.data.data)
      })
      .catch((error) => {
        console.log(error)
      })

    service
      .myOffices(id)
      .then((resp) => {
        setOffices(resp.data.data)
      })
      .catch((error) => {
        console.log(error)
      })
  }

  const handleChangeCandidate = (e) => {
    const selectedOption = e.target.selectedOptions[0]
    const id = e.target.value
    const email = selectedOption.getAttribute("data-email")

    setFormData({
      ...formData,
      badgeId: id,
      gmailEmail: email,
    })
  }

  const handleDelete = (id) => {
    swal({
      title: "Are you sure, you want to delete this ad?",
      icon: "warning",
      className: "w-[500px]",
      buttons: {
        cancel: {
          text: "Cancel",
          visible: true,
        },
        confirm: {
          text: "Delete",
          className: "bg-primary text-white",
        },
      },
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        service
          .deleteDealerMediaAd(id)
          .then((resp) => {
            if (resp.data.success) {
              successMessage("Ad deleted successfully")
              const index = data.findIndex(
                (item: { _id: string }) => item._id === id
              )
              const shallowCopy = [...data]
              shallowCopy.splice(index, 1)
              setData(shallowCopy)
            }
          })
          .catch((error) => console.log(error))
      }
    })
  }

  const clearFilter = () => {
    setPagination({
      pageNumber: 1,
      pageSize: 500,
      adProcessingStatus: "",
      adApprovalStatus: "",
      fullName: "",
    })
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    service
      .updateDealerMediaAd(state.id, state)
      .then((resp) => {
        if (resp.data.success) {
          successMessage("Ad updated successfully")
          setShowModal(false)
          fetchData()
        }
      })
      .catch((err) => console.log(err))
  }

  const validateForm = () => {
    if (!formData.badgeId) {
      errorMessage("Badge ID is required")
      return false
    }

    if (!formData.gmailEmail) {
      errorMessage("Gmail email is required")
      return false
    }

    if (!formData.officeName) {
      errorMessage("Please select office")
      return false
    }

    return true
  }

  const handleAddDelaerAd = (e) => {
    e.preventDefault()

    setSubmitting(true)
    let payload = {}

    const isValid = validateForm()

    if (!isValid) {
      setSubmitting(false)
      return
    }

    if (!formData.isAiEnable) {
      payload = {
        badgeId: formData.badgeId,
        officeId: formData.officeId,
        gmailEmail: formData.gmailEmail,
        officeName: formData.officeName,
        campaignName: formData.campaignName,
        isAiEnable: formData.isAiEnable,
        recruiting_interview: [],
      }
    } else {
      payload = {
        badgeId: formData.badgeId,
        gmailEmail: formData.gmailEmail,
        campaignName: formData.campaignName,
        officeName: formData.officeName,
        officeId: formData.officeId,
        isAiEnable: formData.isAiEnable,
        recruiting_interview: formData.recruiting_interview.map((item) => ({
          ...item,
          start_time: convertTo12HourFormat(item.start_time),
          end_time: convertTo12HourFormat(item.end_time),
        })),
      }
      const conflict = hasTimeSlotConflict(formData.recruiting_interview)
      if (conflict) {
        errorMessage(conflict)
        setSubmitting(false)
        return
      }
    }

    service
      .requestDealerAd(payload)
      .then((resp) => {
        successMessage(resp.data.message)
        setAddModal(false)
        fetchData()
        setSubmitting(false)
        setShowRecruiting(false)
        setFormData({
          ...formData,
          isAiEnable: false,
        })
      })
      .catch((error) => {
        console.log(error)
        setSubmitting(false)
      })
  }

  const handleInterviewChange = (index, field, value) => {
    const updatedInterviews = [...formData.recruiting_interview]
    updatedInterviews[index][field] = value

    // If changing end_time and start_time exists, validate the 2-hour difference
    if (field === "end_time" && updatedInterviews[index].start_time) {
      const interviews: any = validateTimeGap(
        updatedInterviews,
        updatedInterviews[index].start_time,
        value,
        index
      )
      setFormData({
        ...formData,
        recruiting_interview: interviews,
      })
    } else {
      setFormData({
        ...formData,
        recruiting_interview: updatedInterviews,
      })
    }
  }

  const addInterview = () => {
    // Get the next block letter based on current array length
    const nextBlockLetter = String.fromCharCode(
      65 + formData.recruiting_interview.length
    )

    setFormData({
      ...formData,
      recruiting_interview: [
        ...formData.recruiting_interview,
        {
          block_name: nextBlockLetter,
          date: "",
          start_time: "",
          end_time: "",
          interview_type: "Virtual Meeting",
          office_name: "",
          address: "",
          city: "",
          time_zone: "",
          state: "",
          zip_code: "",
          custom_location: false,
        },
      ],
    })
  }

  const removeInterview = (index) => {
    // Create a copy of the interviews array
    const updatedInterviews = [...formData.recruiting_interview]

    // Remove the interview at the specified index
    updatedInterviews.splice(index, 1)

    // Reassign block_name for all interviews based on their new position
    updatedInterviews.forEach((interview, idx) => {
      interview.block_name = String.fromCharCode(65 + idx)
    })

    setFormData({
      ...formData,
      recruiting_interview: updatedInterviews,
    })
  }

  const handleChangeOffice = (e) => {
    const id = e.target.value
    const selectedOption = e.target.selectedOptions[0]
    const name = selectedOption.getAttribute("data-name")

    setFormData({
      ...formData,
      officeName: name,
      officeId: id,
    })
  }

  const handleNext = () => {
    const isValid = validateForm()

    if (!isValid) {
      return
    } else {
      setShowRecruiting(true)
    }
  }

  return (
    <Fragment>
      <div className="flex items-center justify-between">
        <div className="flex flex-col mb-4">
          <h1 className="page-title">
            Dealer Media Ads
          </h1>
          <p className="page-subtitle">View all</p>
        </div>
        <button
          onClick={() => setAddModal(true)}
          className="btn-dark"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-5 h-5"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 6v12m6-6H6"
            />
          </svg>
          Request Ad
        </button>
      </div>
      <Table
        data={data}
        handleExport={handleExport}
        pagination={pagination}
        setData={setData}
        exporting={exporting}
        setPagination={setPagination}
        showSearch={false}
        loadingData={loading}
        filters={
          <Filters
            clearFilter={clearFilter}
            pagination={pagination}
            setPagination={setPagination}
          />
        }
        totalItems={totalItems}
        columns={columns}
      />

      {/* Update Ad Modal */}
      <Modal
        width="w-full md:w-1/2"
        showModal={showModal}
        setShowModal={setShowModal}
        title="Update Media Ad"
      >
        <form onSubmit={handleSubmit} className="flex flex-col gap-3">
          <div className="flex-1 flex flex-col gap-1.5 min-w-[150px]">
            <label className="field-label">Campaign Name</label>
            <input
              value={state.campaignName}
              onChange={(e) =>
                setState({ ...state, campaignName: e.target.value })
              }
              type="text"
              className="w-full px-3 py-2 text-sm"
            />
          </div>
          <div className="flex gap-3">
            <div className="flex-1 flex flex-col gap-1.5 min-w-[150px]">
              <label className="field-label">Approval Status</label>
              <select
                onChange={(e) =>
                  setState({
                    ...state,
                    adApprovalStatus: e.target.value,
                  })
                }
                value={state.adApprovalStatus}
                className="w-full px-3 py-2 text-sm"
              >
                <option value="All">All</option>
                <option value="UNDER REVIEW">UNDER REVIEW</option>
                <option value="DENIED">DENIED</option>
                <option value="APPROVED">APPROVED</option>
              </select>
            </div>
            <div className="flex-1 flex flex-col gap-1.5 min-w-[150px]">
              <label className="field-label">Ad Status</label>
              <select
                onChange={(e) =>
                  setState({
                    ...state,
                    adProcessingStatus: e.target.value,
                  })
                }
                value={state.adProcessingStatus}
                className="w-full px-3 py-2 text-sm"
              >
                <option value="All">All</option>
                <option value="In Process">In Process</option>
                <option value="Upcoming">Upcoming</option>
                <option value="Completed">Completed</option>
              </select>
            </div>
          </div>
          <div className="flex gap-3">
            <div className="flex-1 flex flex-col gap-1.5 min-w-[150px]">
              <label className="field-label">Ad Amount</label>
              <input
                type="text"
                value={state.adAmount}
                onChange={(e) =>
                  setState({ ...state, adAmount: e.target.value })
                }
                placeholder="$0.00"
                className="w-full px-3 py-2 text-sm"
              />
            </div>
            <div className="flex-1 flex flex-col gap-1.5 min-w-[150px]">
              <label className="field-label">Ad Spend</label>
              <input
                type="text"
                value={state.adSpent}
                onChange={(e) =>
                  setState({ ...state, adSpent: e.target.value })
                }
                placeholder="$0.00"
                className="w-full px-3 py-2 text-sm"
              />
            </div>
          </div>

          <div className="flex-1 flex flex-col gap-1.5 min-w-[150px]">
            <label className="field-label">Admin Notes</label>
            <textarea
              value={state.notes}
              onChange={(e) => setState({ ...state, notes: e.target.value })}
              rows={4}
              className="w-full px-3 py-2 text-sm"
            />
          </div>

          <button type="submit" className="btn-dark">
            Update
          </button>
        </form>
      </Modal>

      {/* Request Ad Modal */}
      <Modal
        width="w-full md:w-1/2"
        showModal={addModal}
        setShowModal={setAddModal}
        title="Request Ad"
      >
        <form onSubmit={handleAddDelaerAd} className="">
          {showRecruiting ? (
            formData.recruiting_interview.map((item, index) => (
              <div key={item.block_name} className="pb-5 border-b">
                <div className="flex items-center gap-3">
                  <h1 className="my-3 text-lg font-medium text-zinc-800">
                    Interview Session | Block {ALPHABETS[index + 1]}
                  </h1>
                  {index !== 0 && (
                    <button
                      type="button"
                      onClick={() => removeInterview(index)}
                      className="text-red-600"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="w-5 h5"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
                        />
                      </svg>
                    </button>
                  )}
                </div>
                <div className="grid grid-cols-2 gap-3">
                  <div className="flex-1 col-span-2 flex flex-col gap-1.5 min-w-[150px]">
                    <label className="field-label">Date</label>
                    <input
                      type="date"
                      onChange={(e) =>
                        handleInterviewChange(index, "date", e.target.value)
                      }
                      value={item.date}
                      // min={selectedDate}
                      // max={minSelectableDate}
                      defaultValue={""}
                      placeholder="Date"
                      className="w-full px-3 py-2 text-sm"
                    />
                  </div>
                  <div className="flex-1 flex flex-col gap-1.5 min-w-[150px]">
                    <label className="field-label">Start Time</label>
                    <input
                      type="time"
                      value={item.start_time}
                      onChange={(e) =>
                        handleInterviewChange(
                          index,
                          "start_time",
                          e.target.value
                        )
                      }
                      placeholder="Start Time"
                      className="w-full px-3 py-2 text-sm"
                    />
                  </div>
                  <div className="flex-1 flex flex-col gap-1.5 min-w-[150px]">
                    <label className="field-label">End Time</label>
                    <input
                      type="time"
                      value={item.end_time}
                      onChange={(e) =>
                        handleInterviewChange(index, "end_time", e.target.value)
                      }
                      placeholder="End Time"
                      className="w-full px-3 py-2 text-sm"
                    />
                  </div>
                  <div className="flex-1 flex flex-col gap-1.5 min-w-[150px]">
                    <label className="field-label">Timezone</label>
                    <select
                      onChange={(e) =>
                        handleInterviewChange(
                          index,
                          "time_zone",
                          e.target.value
                        )
                      }
                      name="position"
                      value={item.time_zone}
                      className="w-full px-3 py-2 text-sm"
                    >
                      <option value="">Select Timezone</option>
                      {NEW_TIMEZONE.map((item) => (
                        <option key={item} value={item}>
                          {item}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="flex-1 flex flex-col gap-1.5 min-w-[150px]">
                    <label className="field-label">Zoom</label>
                    <select
                      onChange={(e) =>
                        handleInterviewChange(
                          index,
                          "interview_type",
                          e.target.value
                        )
                      }
                      name="interview_type"
                      value={item.interview_type}
                      className="w-full px-3 py-2 text-sm"
                    >
                      <option value="">Select</option>
                      <option value="Virtual Meeting">Virtual Meeting</option>
                      <option disabled value="In-Person">
                        In-Person
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="grid grid-cols-2 gap-3">
              <div className="flex flex-col flex-1 gap-1 min-w-[150px]">
                <label className="text-sm text-gray-700">Campaign Name</label>
                <input
                  value={formData.campaignName}
                  onChange={(e) =>
                    setFormData({ ...formData, campaignName: e.target.value })
                  }
                  type="text"
                  className="w-full px-3 py-2 text-sm"
                />
              </div>
              <div className="flex flex-col gap-1">
                <label className="field-label">Companies</label>
                <select
                  onChange={handleChangeCompany}
                  name="companyId"
                  required
                  className="w-full px-3 py-2 text-sm"
                >
                  <option>Select</option>
                  {companies.map((item: any) => (
                    <option key={item.companyId} value={item.companyId}>
                      {item.title}
                    </option>
                  ))}
                </select>
              </div>
              <div className="flex flex-col gap-1">
                <label className="field-label">Candidates</label>
                <select
                  name="leader_id"
                  onChange={handleChangeCandidate}
                  required
                  className="w-full px-3 py-2 text-sm"
                >
                  <option>Select</option>
                  {companyUsers.map((item: any) => (
                    <option
                      key={item._id}
                      value={item.badgeId}
                      data-email={item.email}
                    >
                      {item.fullname}
                    </option>
                  ))}
                </select>
              </div>
              <div className="flex flex-col flex-1 gap-1 min-w-[150px]">
                <label className="text-sm text-gray-700">Gmail Email</label>
                <input
                  type="text"
                  value={formData.gmailEmail}
                  onChange={(e) =>
                    setFormData({ ...formData, gmailEmail: e.target.value })
                  }
                  placeholder="Email"
                  className="w-full px-3 py-2 text-sm"
                />
              </div>
              <div className="flex flex-col gap-1">
                <label className="text-sm text-gray-700">Offices</label>
                <select
                  name="leader_id"
                  onChange={handleChangeOffice}
                  required
                  className="w-full px-3 py-2 text-sm"
                >
                  <option>Select</option>
                  {offices.map((item: any) => (
                    <option
                      key={item._id}
                      value={item._id}
                      data-name={item.name}
                    >
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          )}
          {!showRecruiting ? (
            <div className="flex w-full gap-3 mt-4">
              <div className="flex-1">
                <button
                  type="button"
                  onClick={() => setFormData({ ...formData, isAiEnable: true })}
                  className={classNames(
                    "border border-black rounded-lg w-full px-4 py-2.5",
                    {
                      "bg-black text-white": formData.isAiEnable,
                    }
                  )}
                >
                  Scheduling
                </button>
                <p className="mt-2 text-gray-800 ">
                  <span className="font-medium">Scheduling:</span> An agent will
                  screen your candidates and then schedule them to your
                  available interview slots on Connect, giving them a google
                  meet link for the virtual interview.
                </p>
              </div>
              <div className="flex-1">
                <button
                  type="button"
                  onClick={() =>
                    setFormData({ ...formData, isAiEnable: false })
                  }
                  className={classNames(
                    "border border-black w-full rounded-lg px-4 py-2.5",
                    {
                      "bg-black text-white": !formData.isAiEnable,
                    }
                  )}
                >
                  Screening
                </button>
                <p className="mt-2 text-gray-800">
                  <span className="font-medium">Screening Only:</span> An AI
                  Agent will screen your candidates and then let them know a
                  manager will reach out in the next 1-4 hours. These candidates
                  appears in your "Interested Candidates" list on Connect.
                </p>
              </div>
            </div>
          ) : (
            <button
              type="button"
              className="btn-dark mt-2"
              onClick={addInterview}
            >
              Add
            </button>
          )}
          {!formData.isAiEnable ? (
            <div className="flex gap-3 mt-2">
              <button
                type="submit"
                disabled={submitting}
                className="btn-dark w-full"
              >
                {submitting ? "Requesting..." : "Add"}
              </button>
              <button
                type="button"
                onClick={() => setAddModal(false)}
                className="w-full py-2 text-gray-900 border rounded-md zborder-black"
              >
                Cancel
              </button>
            </div>
          ) : showRecruiting ? (
            <div className="flex gap-3 mt-2">
              <button
                type="button"
                onClick={() => setShowRecruiting(false)}
                className="btn-dark w-full"
              >
                Back
              </button>
              <button
                type="submit"
                disabled={submitting}
                className="w-full py-2 text-gray-900 border rounded-md disabled:cursor-not-allowed zborder-black"
              >
                {submitting ? "Submitting" : "Submit"}
              </button>
            </div>
          ) : (
            <button
              type="button"
              onClick={handleNext}
              className="btn-dark"
            >
              Next
            </button>
          )}
        </form>
      </Modal>
    </Fragment>
  )
}

export const Filters = ({ clearFilter, pagination, setPagination }: any) => {
  const filters = { ...pagination }
  delete filters.pageNumber
  delete filters.pageSize
  const hasFilters = Object.values(filters).some((item) => item)

  return (
    <div className="flex items-center flex-1 gap-4 -mt-6">
      <div className="flex-1">
        <label className="field-label">Full Name</label>
        <input
          className="w-full px-3 py-2 text-sm"
          type="text"
          value={pagination.fullName}
          placeholder="Search by Name"
          onChange={(e) => {
            setPagination({
              ...pagination,
              fullName: e.target.value,
            })
          }}
        />
      </div>
      <div className="flex-1">
        <label className="field-label">Ad Status</label>
        <select
          value={pagination.adProcessingStatus}
          className="w-full px-3 py-2 text-sm"
          onChange={(e) =>
            setPagination({
              ...pagination,
              adProcessingStatus: e.target.value,
            })
          }
        >
          <option value="All">All</option>
          <option value="In Process">In Process</option>
          <option value="Upcoming">Upcoming</option>
          <option value="Completed">Completed</option>
        </select>
      </div>
      <div className="flex-1">
        <label className="field-label">Approval Status</label>
        <select
          className="w-full px-3 py-2 text-sm"
          value={pagination.adApprovalStatus}
          onChange={(e) =>
            setPagination({
              ...pagination,
              adApprovalStatus: e.target.value,
            })
          }
        >
          <option value="All">All</option>
          <option value="UNDER REVIEW">UNDER REVIEW</option>
          <option value="DENIED">DENIED</option>
          <option value="APPROVED">APPROVED</option>
        </select>
      </div>

      {hasFilters && (
        <button
          onClick={() => {
            clearFilter()
          }}
          className="btn-dark whitespace-nowrap"
        >
          Clear Filters
        </button>
      )}
    </div>
  )
}
